import React from 'react';
import { Text } from "../../../Components/Themed";
import type { PublicPlayerProps, TextTagProps } from '../../../types';
import PlayerTag from './PlayerTag';

type TagRendererProps = {
    tag:TextTagProps,
    data?:PublicPlayerProps,
    onPress: (tag:TextTagProps, data?:PublicPlayerProps) => void
}
const TagRenderer = ({ tag, data, onPress }:TagRendererProps) => {

    switch(tag.type){
        case 'player':
            return (
                <PlayerTag tag={tag} player={data} onPress={onPress} />
            )
        default:
            return (
                <Text theme='description'>{tag.tag}</Text>
            )
    }

}

export default TagRenderer